module.exports = __webpack_public_path__ + "static/media/92180002-Jxf1wSgs.92702cb9.JPG";